import React, { memo } from 'react';
import sanitizeHtml from 'sanitize-html';
import { Line } from '@yme/assets/icons';
import { SVGIcon } from '@yme/atoms/svg-icon';
import { useWindowSize } from '@yme/hooks/useWindowSize';
import { useTranslation } from '@yme/services/i18n';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { RegularTextLevel1, RegularTextLevel3 } from '@yme/tokens/typography';
import { getMessageWithLinks, getNoResultsHeader, getNoResultsMessage } from './helpers';
import { NoResultsMessageStyled } from './styled';
function DidYouMeanComponent({ query, autoCorrectQueryResult, didYouMeanOptions, didYouMeanElements, }) {
    const { t } = useTranslation();
    const { isMobileView } = useWindowSize();
    return (React.createElement(FlexWrapper, { flexDirection: "column" },
        React.createElement(RegularTextLevel1, { weight: 500 }, getNoResultsHeader(t('globalSearch_noResultsAutocorrect_header'), autoCorrectQueryResult)),
        React.createElement(FlexWrapper, { mt: "8px", mb: "32px", mbDesktop: "40px", gap: isMobileView ? '8px' : '0px', flexDirection: isMobileView ? 'column' : 'row' },
            React.createElement(NoResultsMessageStyled, { dangerouslySetInnerHTML: {
                    __html: sanitizeHtml(getNoResultsMessage(t('globalSearch_noResultsAutocorrect_description'), query)),
                } }),
            Boolean(didYouMeanOptions.length) && (React.createElement(React.Fragment, null,
                !isMobileView && React.createElement(SVGIcon, { type: Line }),
                React.createElement(RegularTextLevel3, null, getMessageWithLinks(t('globalSearch_noResultsAutocorrect_text'), didYouMeanElements)))))));
}
export const DidYouMean = memo(DidYouMeanComponent);
